export enum PeopleSubmenuOptions {
    People = "people",
    Teams = "teams",
}
